<template>
  <div class="m-4 mx-auto my-6 flex max-w-xl flex-col rounded-lg bg-white p-4">
    <h1 class="text-lg font-normal">
      Please share any information that would help us match you with pre-vetted
      candidates in our talent pool.
    </h1>
    <v-textarea
      v-model.trim="matchingInfo"
      data-cy="consult.matchingoptimizer.input.info"
      rows="4"
      variant="outlined"
      maxlength="4000"
    ></v-textarea>
  </div>
</template>

<script>
import { getConsultState } from '@/services/consultService';

export default {
  emits: ['update'],
  data() {
    return {
      matchingInfo: '',
    };
  },
  watch: {
    matchingInfo() {
      this.$emit('update', {
        key: 'matchingInfo',
        Q: `Please share any information that would help us match you with pre-vetted
      candidates in our talent pool?`,
        A: this.matchingInfo,
      });
    },
  },
  created() {
    this.matchingInfo =
      getConsultState().questions.find((item) => item.key === 'matchingInfo')
        ?.A || '';
  },
};
</script>
